import React, { createContext, useContext, useState, useEffect } from "react";

const CookieContext = createContext();

export const CookieProvider = ({ children }) => {
  const [consent, setConsent] = useState(null);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem("cookieConsent");
    if (savedConsent) {
      setConsent(JSON.parse(savedConsent));
    }
  }, []);

  const acceptAll = () => {
    const allConsent = {
      essential: true,
      analytics: true,
      marketing: true,
      functional: true,
      date: new Date().toISOString(),
    };
    saveConsent(allConsent);
  };

  const declineNonEssential = () => {
    const essentialOnly = {
      essential: true,
      analytics: false,
      marketing: false,
      functional: false,
      date: new Date().toISOString(),
    };
    saveConsent(essentialOnly);
  };

  const saveConsent = (preferences) => {
    setConsent(preferences);
    localStorage.setItem("cookieConsent", JSON.stringify(preferences));
    setShowSettings(false);
  };

  return (
    <CookieContext.Provider
      value={{
        consent,
        showSettings,
        setShowSettings,
        acceptAll,
        declineNonEssential,
        saveConsent,
      }}
    >
      {children}
    </CookieContext.Provider>
  );
};

export const useCookie = () => {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error("useCookie must be used within a CookieProvider");
  }
  return context;
};

export const useConsent = () => {
  const { consent } = useCookie();
  
  const hasConsent = (category) => {
    if (!consent) return false;
    return !!consent[category];
  };

  return {
    consent,
    hasConsent,
    analytics: hasConsent("analytics"),
    marketing: hasConsent("marketing"),
    functional: hasConsent("functional"),
    essential: hasConsent("essential"),
  };
};
